import React, { useState, useEffect } from 'react';

import AgencyEntity from '../../Components/AgencyEntity'
import ModalWarn from '../../Components/Modal/Warn/index'
import { horarioPadraoLabelFactory, horariosPadraoLabelSemRepeticao, normalizeKeys } from '../../utils';
import { estados } from '../../constants'

export default function EditAgencyEntity(props) {

    const [ agency, setAgency ] = useState({
        codigo_orgao: "",
        nome_orgao: "",
        nome_rede_atendimento: "",
        abrangencia: "",
        uf: "",
        nome_municipio: "",
        horario: [
            {
                dias_semana: "",
                hora_inicio: "",
                hora_fim: ""
            }
        ],
        atendimento_presencial: false,
        data_credenciamento: "",        
        referencia_autorizacao: "",
        orgaos_autorizados: "",
        realiza_atendimento: false 
    });
    const [horarioPadraoAtendimentoOptions, setHorarioPadraoAtendimentoOptions] = useState([]);
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)
    const [successMsg, setSuccessMsg] = useState();
    const [ loadingAdd, setLoadingAdd ] = useState(false);    
    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");
    const [msgErrorAccreditationDate, setMsgErrorAccreditationDate] = useState();
    const [ stateOptions ] = useState(estados);
    const [ municipioOptions, setMunicipioOptions ] = useState([])

    useEffect(()=>{  
        async function loadWorkingHoursOptions() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : ""
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/listaHorariosAtendimentoOrgao`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
    
                        var horarios = [];
                        var obj = {};

                        data.forEach((horariosDoOrgao) => {
                            obj = horarioPadraoLabelFactory(horariosDoOrgao);

                            horarios.push(obj);
                        });

                        setHorarioPadraoAtendimentoOptions(horariosPadraoLabelSemRepeticao(horarios));
                    });
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }
        if ((props.location.state?.result_search !== undefined)) {  //Carrega as informações de cadastro da unidade antes do clique no botão "Cadastrar Gestor Regional"
            const agencyLowercase = normalizeKeys(props.location.state.result_search);
            setAgency(agencyLowercase);
            listaMunicipios(agencyLowercase.uf); 
            const msg = sessionStorage.getItem('successMsg');
            sessionStorage.removeItem('successMsg');
            setSuccessMsg(msg);
            if (msg) { //Adiciona o CPF do gestor que acabou de ser inserido. Apaga a mensagem de sucesso após algum clique em um input box ou button
                setTimeout(() => { document.getElementById('bntIncluirVincular').click(); }, 50); //deixa o click() para o final da fila de execução — o que garante que o input e qualquer onInput ou onChange associado tenham sido processados.
                setTimeout(() => { document.addEventListener('click', handleEraseMsg); }, 50); 
            }                    
        }
        loadWorkingHoursOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleEraseMsg (event) {
        if (event.target.matches('input, button')) {
            setSuccessMsg(undefined);
            document.removeEventListener('click', handleEraseMsg); //Remove o listener para não consumir recurso.
          }
    }

     // ================================================================================

    async function listaMunicipios(uf) {
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",
                uf: uf
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/listaMunicipios`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data) {

                    var municipios = [];
                    var obj = {};

                    data.forEach((h) => {
                        obj = {
                            value: h.CODIGO_MUNICIPIO,
                            label: h.NOME_MUNICIPIO
                        };

                        municipios.push(obj);
                    });

                    setMunicipioOptions(municipios);
                });
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    const onSubmitAgencyData = async (data) => {

        setLoadingAdd(true);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "", //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                codigo_orgao: data.codigo_orgao,
                nome_orgao: data.nome_orgao,
                nome_rede_atendimento: data.nome_rede_atendimento,
                abrangencia: data.abrangencia,
                uf: data.uf,
                codigo_municipio: data.codigo_municipio,
                horarios: data.horarios,
                atendimento_presencial: data.atendimento_presencial,
                data_credenciamento: data.data_credenciamento,
                referencia_autorizacao: data.referencia_autorizacao,
                orgaos_autorizados: data.orgaos_autorizados,
                realiza_atendimento: data.realiza_atendimento,
                ips_permitidos: data.ips_permitidos
            }),
        };
         
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/editaOrgao`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data_request) {
                    const agency_added = {
                        message: data_request.message,
                        newStatus: data_request.newStatus
                    }
                    setLoadingAdd(false);
                    
                    props.history.push('gerenciarOrgao', agency_added);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    data.message = data.messages ? data.messages[0].message : data.message
                    if (!!data.errorCode && !!data.message) {
                        if (data.errorCode === 'ACCREDITATION_DATE_INVALID') {
                            setMsgErrorAccreditationDate(data.message);
                        } else {
                            setMessageError(data.message);
                            setModalError(true);
                        }
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                    }

                    setLoadingAdd(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingAdd(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingAdd(false);
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    };
 
    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <AgencyEntity
                pageTitle='Edição da rede de atendimento' 
                workingHoursOptions={horarioPadraoAtendimentoOptions}
                setWorkingHoursOptions={setHorarioPadraoAtendimentoOptions}
                onSubmitData={onSubmitAgencyData} 
                stateOptions={stateOptions}
                listMunicipality={listaMunicipios}
                municipalityOptions={municipioOptions}
                agency={agency} 
                loadingAdd={loadingAdd}
                setLoading={setLoadingAdd}
                modalError ={modalError}
                setModalError={setModalError} 
                setMessageError={setMessageError} 
                messageError={messageError} 
                setMsgErrorAccreditationDate={setMsgErrorAccreditationDate}
                msgErrorAccreditationDate={msgErrorAccreditationDate}
                buttonCancelRoute='/gerenciarOrgao' 
                history={props.history} 
                fromSuccessMsg={successMsg} 
            />
        </>
    );
}